import React from 'react';
import Hero from '../components/Hero';
import NewArrivals from '../components/NewArrivals';
import TrendingNow from '../components/TrendingNow';
import MegaGenieDeals from '../components/MegaGenieDeals';
import Bestsellers from '../components/Bestsellers';
import ClearanceSale from '../components/ClearanceSale';
import Categories from '../components/Categories';
import Heritage from '../components/Heritage';
import Services from '../components/Services';

const HomePage = ({ onCategorySelect }) => {
  const sections = [
    <Hero />,
    <NewArrivals />,
    <TrendingNow />,
    <MegaGenieDeals />,
    <Bestsellers />,
    <ClearanceSale />,
    <Categories onCategorySelect={onCategorySelect} />,
    <Heritage />,
    <Services />,
  ];

  return (
    <>
      {sections.map((section, i) => (
        <div
          key={i}
          className="slide-in"
          style={{ animationDelay: `${i * 0.08}s` }}
        >
          {section}
        </div>
      ))}
    </>
  );
};

export default HomePage;
